import type { ReactiveController, ReactiveControllerHost } from "lit";

export class ClockController implements ReactiveController {
  host: ReactiveControllerHost;

  remainingSeconds = 35;

  timeout = 1000;

  private timerID?: ReturnType<typeof setInterval> | number = 0;

  constructor(host: ReactiveControllerHost, seconds = 60) {
    (this.host = host).addController(this);
    this.remainingSeconds = seconds;
  }

  countdown(): void {
    this.remainingSeconds -= 1;
    if (this.remainingSeconds === 0) {
      window.dispatchEvent(new CustomEvent("activity-has-timed-out"));
    }
  }

  hostConnected() {
    // Start a timer when the host is connected
    this.timerID = setInterval(() => {
      this.countdown();

      // Update the host with new value
      this.host.requestUpdate();
    }, this.timeout);
  }

  hostDisconnected() {
    // Clear the timer when the host is disconnected
    clearInterval(this.timerID);
    this.timerID = undefined;
  }
}
